import { SegmentModeType } from '@/types/api-types';
import { getCargoRatePerUnit } from '@/utils/cargo';
import { formatPrice } from '@/utils/format';
import { calcPercentChange } from '@/utils/helpers/maths';
import { calcRatesChartRange, convertRatesToChartData, getRatesSeriesLabel } from '@/utils/rates';

import { MarketRateModel } from '../types';

const pricePlaceholder = '$0.00';

export const formatMarketRateModelData = (rates?: MarketRateModel, mode?: SegmentModeType, compact?: boolean) => {
  const { lastValue, firstValue } = rates || {};
  const currency = lastValue?.currency || 'usd';
  const hasRates = !!lastValue?.value;
  const percentChange = lastValue && firstValue ? calcPercentChange(lastValue.value, firstValue.value) : 0;
  const seriesLabels = getRatesSeriesLabel(rates);
  const unitString = mode ? getCargoRatePerUnit(mode, seriesLabels?.size, compact) : '';

  const currencyString = 'USD';
  let priceString = pricePlaceholder;
  let percentString = 'No rates';

  if (hasRates) {
    // If a value exists
    priceString = formatPrice(lastValue.value, currency, 1);
    percentString = percentChange > 0 ? `+${percentChange}%` : `${percentChange}%`;
  }

  const chartData = convertRatesToChartData(rates);
  const { min, max, average, domain: chartRange } = calcRatesChartRange(chartData);

  return {
    priceString,
    percentString,
    percentChange,
    unitString,
    currencyString,
    lowPriceString: hasRates ? formatPrice(min, currency, 1) : pricePlaceholder,
    highPriceString: hasRates ? formatPrice(max, currency, 1) : pricePlaceholder,
    averagePriceString: hasRates ? formatPrice(average, currency, 1) : pricePlaceholder,
    hasRates,
    currency,
    chart: {
      data: chartData,
      seriesLabels,
      range: chartRange,
    },
  };
};
